import './LoadingOverlay.css';

const LoadingOverlay = ({ text = "Loading..." }) => {
  return (
    <div className="grid-loading-overlay">
      <div className="spinner" />
      <span className="loading-text">{text}</span>
    </div>
  );
};

export default LoadingOverlay;
